export const CLICKED_SUBSCRIBE_CTA = 'Clicked Subscribe CTA';
export const ANONYMOUS_ID_CONFLICT_CODE = 1019;
export const CREATE_ACCOUNT = 'createAccount';
export const SIGN_IN = 'signIn';
export const LEARN_MORE = 'learnMore';
export const HOME = 'home';
export const OPEN_HOUSE_COOKIE = 'open_house_modal';
export const LARGE_DESKTOP = 'largeDesktop';
export const DESKTOP = 'desktop';
export const TABLET = 'tablet';
export const SMALL_TABLET = 'smallTablet';
export const EXTRA_LARGE_MOBILE = 'extralargeMobile';
export const LARGE_MOBILE = 'largeMobile';
export const MEDIUM_MOBILE = 'mediumMobile';
export const SMALL_MOBILE = 'smallMobile';
export const RL_VERIFY_EMAIL_CLICKED = 'Verify Email Clicked';
export const RL_CTA_CLICKED = 'CTA Clicked';
export const RL_PAYWALL_DISPLAYED = 'Premium Paywall Displayed';
